import { gmRequest } from '.';

export default {
  getEventContent: (eventSlug) => gmRequest(`/api/cms/events/${eventSlug}`),
};
